import { useState } from "react";
import { Clock, CalendarDays } from "lucide-react";
import { AppHeader } from "@/components/AppHeader";
import { BottomTabBar } from "@/components/BottomTabBar";
import EmployeeHours from "@/pages/employee/EmployeeHours";
import EmployeeHolidays from "@/pages/employee/EmployeeHolidays";

const TABS = [
  { id: "ore", label: "Ore", icon: Clock },
  { id: "ferie", label: "Ferie", icon: CalendarDays },
];

export default function EmployeeApp() {
  const [tab, setTab] = useState("ore");
  return (
    <div className="min-h-screen pb-32">
      <AppHeader />
      <main className="max-w-md mx-auto px-4 py-5 fade-in" key={tab}>
        {tab === "ore" && <EmployeeHours />}
        {tab === "ferie" && <EmployeeHolidays />}
      </main>
      <BottomTabBar tabs={TABS} active={tab} onChange={setTab} />
    </div>
  );
}
